import React from 'react';

const Point = ({ variant }) => {
    return <div className={`status-point point-${variant}`} />;
};

export default Point;
